export default {"src":"/_next/static/media/cart_filled.133698c0.svg","height":24,"width":24};